<evc-modal
  [showReduceButton]="false"
  [options]="options()"
  [styles]="{ width: '500px' }">
  <ng-container modal-title>{{ i18n().title | translate }}</ng-container>

  <form
    modal-content
    [formGroup]="form">
    <evc-input
      #field
      size="md"
      [placeholder]="i18n().placeholder | translate"
      formControlName="name" />
  </form>

  <evc-button
    data-testid="modal-submit"
    modal-actions
    type="primary"
    [text]="i18n().action | translate"
    (click)="submit()" />
  <evc-button
    data-testid="modal-cancel"
    modal-actions
    frame="ghost"
    [text]="i18n().cancel | translate"
    (click)="close()" />
</evc-modal>
